export default function getGapYXl(value) {
  switch (value) {
    case 0.5:
      return "xl:gap-y-0.5";
    case 1:
      return "xl:gap-y-1";
    case 2:
      return "xl:gap-y-2";
    case 3:
      return "xl:gap-y-3";
    case 4:
      return "xl:gap-y-4";
    case 5:
      return "xl:gap-y-5";
    case 6:
      return "xl:gap-y-6";
    case 7:
      return "xl:gap-y-7";
    case 8:
      return "xl:gap-y-8";
    case 9:
      return "xl:gap-y-9";
    case 10:
      return "xl:gap-y-10";
    case 12:
      return "xl:gap-y-12";
    case 14:
      return "xl:gap-y-14";
    case 16:
      return "xl:gap-y-16";
    case 20:
      return "xl:gap-y-20";
    case 24:
      return "xl:gap-y-24";
    case 28:
      return "xl:gap-y-28";
    case 32:
      return "xl:gap-y-32";
    case 36:
      return "xl:gap-y-36";
    case 40:
      return "xl:gap-y-40";
    case 44:
      return "xl:gap-y-44";
  }
}
